import React, {useEffect, useState} from 'react';
import {createAxiosEntrepriseInstance} from "../../../axiosEntreprise";
import SidebarWidgets from "../../SidebarWidgets/SidebarWidgets";
import CorbeilleSvg from "../../../boiteAOutils/SVG/CorbeilleSvg";
import moment from "moment";
import FlecheRevenirSvg from "../../../boiteAOutils/SVG/FlecheRevenirSvg";
import {useStores} from "../../../stores/Context";
import WidgetBibliothequeImagesCamera from "./WidgetBibliothequeImagesCamera";
import WidgetBibliothequeImagesAddPhoto from "./WidgetBibliothequeImagesAddPhoto";
import {observer} from "mobx-react";
import WidgetBibliothequeImageUpload from "./WidgetBibliothequeImageUpload";
import WidgetBibliothequeImageUploadQrCode from "./WidgetBibliothequeImageUploadQrCode";
import CrayonSvg from "../../../boiteAOutils/SVG/CrayonSvg";


const WidgetBibliothequeImagesContent = observer(() => {
    const {widgetStore, bibliothequeImagesStore} = useStores();
    // const [images, setImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [flippedImages, setFlippedImages] = useState({});
    const [longPressTimeout, setLongPressTimeout] = useState(null);
    const [columns, setColumns] = useState(4);
    const [showElements, setShowElements] = useState([]);
    const handleImageClick = (image) => {
        setSelectedImage(image);
    };
    const [loadImage, setLoadImage] = useState(true);
    const [images, setImages] = useState([]);
    const [error, setError] = useState('');
    const api = createAxiosEntrepriseInstance();

    useEffect(() => {
        if (!loadImage || !widgetStore.idTotem) return;
        let active = true;
        setError('');
        api.get('/api/bibliothequeImages/getAllImagesByIdTotem/' + widgetStore.idTotem)
            .then((res) => {
                if (active) setImages(Array.isArray(res.data) ? res.data : []);
            })
            .catch(() => {
                if (active) setError("Les images n’ont pas pu être chargées. Réessayez dans quelques instants.");
            })
            .finally(() => {
                if (active) setLoadImage(false);
            });
        return () => { active = false; };
    }, [loadImage, widgetStore.idTotem]);

    const handleDelete = async (id) => {
        try {
            setError('');
            await api.post('/api/bibliothequeImages/deleteImageById', { id });
            setLoadImage(true);
            setShowElements([]);
        } catch (requestError) {
            setError(requestError.response?.data?.message || "L’image n’a pas pu être supprimée.");
        }
    };


    const handleLongPress = (index) => {
        setFlippedImages((prev) => ({...prev, [index]: !prev[index]}));
    };

    const handlePointerDown = (index) => {
        const timeout = setTimeout(() => handleLongPress(index), 300); // Détection d'un clic long (600ms)
        setLongPressTimeout(timeout);
    };

    const handlePointerUp = () => {
        if (longPressTimeout) {
            clearTimeout(longPressTimeout);
        }
    };

    const handleRevertImage = (index) => {
        setFlippedImages((prev) => ({...prev, [index]: false}));
    };


    document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
        let touchDuration = setTimeout(function() {
            event.preventDefault();
        }, 500); // 500ms pour détecter un long press

        event.target.addEventListener('touchend', function() {
            clearTimeout(touchDuration);
        });
    });

    const toggleElement = (index) => {
        setShowElements([])
        setShowElements((prevShowElements) => {
            const newShowElements = [...prevShowElements];
            newShowElements[index] = !newShowElements[index];
            return newShowElements;
        });
    }

    return (
        <div className={"contentNiv1 contentNiv1Consignes"}>
            <SidebarWidgets widget={"photos"}/>

                <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%"}}>
                    {error && <div className="alert alert-danger" role="alert" style={{ width: '100%', marginBottom: '1rem' }}>{error}</div>}
                <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "right", width: "100%", marginBottom: "1em"}}>

                    <svg style={{cursor: "pointer"}}
                         onClick={() => setColumns(2)}
                         width="50"
                         height="50"
                         viewBox="0 0 24 24"
                         fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier">
                        <rect style={{stroke: columns === 2 ? "#002335" : "#A8B0B3"}} x="4" y="4" width="16" height="16" rx="2"  stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></rect> </g>
                    </svg>

                    <svg style={{marginRight: "0.5em", fill: columns === 3 ? "#002335" : "#A8B0B3", cursor: "pointer"}}
                         onClick={() => setColumns(3)}
                         width="35"
                         height="35"
                         viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M1740 0c99.24 0 180 80.76 180 180v1560c0 99.24-80.76 180-180 180H180c-99.24 0-180-80.76-180-180V180C0 80.76 80.76 0 180 0h1560ZM894 1800v-774H120v677.25c0 53.213 43.537 96.75 96.75 96.75H894Zm0-906V120H216.75c-53.213 0-96.75 43.537-96.75 96.75V894h774Zm906 809.25V1026h-774v774h677.25c53.213 0 96.75-43.537 96.75-96.75Zm0-809.25V216.75c0-53.213-43.537-96.75-96.75-96.75H1026v774h774Z" fill-rule="evenodd"></path> </g>
                    </svg>

                    <svg style={{marginRight: "1em", fill: columns === 4 ? "#002335" : "#A8B0B3", cursor: "pointer"}}
                         onClick={() => setColumns(4)}
                         width="35"
                         height="35"
                         viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M1800 1320v420c0 33-27 60-60 60h-420v-480h480Zm-600 0v480H720v-480h480Zm-600 0v480H180c-33 0-60-27-60-60v-420h480Zm1200-600v480h-480V720h480Zm-600 0v480H720V720h480Zm-600 0v480H120V720h480Zm1140-600c33 0 60 27 60 60v420h-480V120h420Zm-540 0v480H720V120h480Zm-600 0v480H120V180c0-33 27-60 60-60h420ZM1740 0H180C80.76 0 0 80.76 0 180v1560c0 99.24 80.76 180 180 180h1560c99.24 0 180-80.76 180-180V180c0-99.24-80.76-180-180-180Z" fill-rule="evenodd"></path> </g>
                    </svg>
                </div>

                <div className="listePhotoContent">
                    <div className={`flex-1 grid`} style={{ gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: "4px" }}>
                        {
                        images ? (
                            images.map((photo, index) => (

                                <div className={"contentImages"}>

                                    <div className={"consigneCardContentHeader"} style={{width:"100%", justifyContent: "end"}}>

                                        <div className={"consigneCardContentActionsMenu"}>
                                            <div className={"consigneCardContentActions"}
                                                 onClick={() => toggleElement(index)}>
                                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="8.16667" cy="19.1673" r="4.16667"
                                                            transform="rotate(-90 8.16667 19.1673)" fill="#002335"/>
                                                    <circle cx="32.8337" cy="19.1673" r="4.16667"
                                                            transform="rotate(-90 32.8337 19.1673)" fill="#002335"/>
                                                    <circle cx="20.4997" cy="19.1673" r="4.16667"
                                                            transform="rotate(-90 20.4997 19.1673)" fill="#002335"/>
                                                </svg>
                                            </div>

                                            {
                                                showElements[index] ? (
                                                    <div className={"consigneCardContentActionsContent"} style={{top: "8em"}}>
                                                        <div className={"consigneCardContentActionsItems"}
                                                             onClick={() => handleImageClick(photo.url)}>
                                                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none"
                                                                 xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M2.11215 11.0474C1.73996 10.3991 1.73996 9.6023 2.11215 8.95404C4.07047 5.54313 7.20283 3.33398 10.7328 3.33398C14.2628 3.33398 17.3952 5.5431 19.3535 8.95397C19.7257 9.60222 19.7257 10.399 19.3535 11.0473C17.3952 14.4582 14.2628 16.6674 10.7328 16.6674C7.20282 16.6674 4.07048 14.4582 2.11215 11.0474Z"
                                                                    stroke="#002335" strokeWidth="2"/>
                                                                <ellipse cx="10.7334" cy="10" rx="2.5" ry="2.5"
                                                                         stroke="#002335"
                                                                         strokeWidth="2"/>
                                                            </svg>
                                                            <span
                                                                className={"consigneCardContentActionsItemsName"}>Voir</span>
                                                        </div>
                                                        <div className={"consigneCardContentActionsItemsSeparateur"}></div>
                                                        <div className={"consigneCardContentActionsItems"} onClick={() => handleDelete(photo.id)}>
                                                            <CorbeilleSvg/>
                                                            <span
                                                                className={"consigneCardContentActionsItemsName"}>Supprimer</span>
                                                        </div>
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                    <div >
                                        <img src={process.env.REACT_APP_API_URL+'/'+photo.url} alt={`Photo ${index + 1}`}
                                             className=" w-full h-auto rounded-lg"/>
                                    </div>
                                </div>
                            ))
                        ) : null
                        }
                    </div>
                    {selectedImage && (
                        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center p-4">
                            <img
                                src={process.env.REACT_APP_API_URL+'/'+selectedImage}
                                alt="Selected"
                                className="max-w-full max-h-full rounded-lg"
                            />
                            <button
                                className="absolute top-4 right-4 text-white text-2xl"
                                onClick={() => setSelectedImage(null)}
                            >
                                &times;
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {
                bibliothequeImagesStore.openAddPhoto ? (
                    <WidgetBibliothequeImagesAddPhoto />
                ) : null
            }
            {
                bibliothequeImagesStore.openUploadImage ? (
                    <WidgetBibliothequeImageUpload onAddImage={() => setLoadImage(true)} />
                ) : null
            }
            {
                bibliothequeImagesStore.openCamera ? (
                    <WidgetBibliothequeImagesCamera onAddPhotos={() => setLoadImage(true)}/>
                ) : null
            }
            {
                bibliothequeImagesStore.openUploadQrCode ? (
                    <WidgetBibliothequeImageUploadQrCode />
                ) : null
            }

        </div>

    );
});

export default WidgetBibliothequeImagesContent;
